import { CognitoUserManager } from './CognitoUserManager';
import { getOidcConfig } from './oidcConfig';

export const userManager = new CognitoUserManager(getOidcConfig());
